import React, { Component }  from 'react';
import * as ReactDOM from 'react-dom';
import Company from "./Company";
import {NavLink} from "react-router-dom";
import {Col, Container, Row} from "react-bootstrap";

export default class Publishers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: []
        };
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + "/customer/publisher")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result.data
                    });
                },

                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    render() {
        const { error, isLoaded, items } = this.state;

        let content = null;

        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                <p>Session token has expired. Please, <a href="/account">login</a> again</p>
            </div> :<empty/>}</div>;
        } else if (!isLoaded) {
            content = <div>Loading...</div>;
        } else {
            content = (
                <div id="root">
                    <br/>
                    <div className="list-group">
                        {items.map(item => (
                            <a href={"/publishers/" + item.id.toString()}
                               className="list-group-item list-group-item-action flex-column align-items-start">
                                <div className="d-flex w-70 justify-content-between">
                                    <h5 className="mb-1">{item.name}</h5>
                                    <small>
                                        <a href={item.site}>Site</a>
                                        <br/>
                                    </small>
                                </div>
                                <div class="row g-6">
                                    <div className="col-sm-10 alert alert-success">{item.description}</div>

                                    {item.address ? <div className="col-sm align-items-end" style={{
                                        width: "8rem"
                                    }}>
                                        <div align="right" class="card align-items-end" style={{
                                            float:"right",
                                            width: "8rem"
                                        }}>
                                            <img height="110px" className="card-img-top" src="https://cdn-icons-png.flaticon.com/512/854/854952.png"
                                                 alt="Card image cap"/>
                                            <ul className="list-group list-group-flush">
                                                <li className="list-group-item">{item.address.city}, {item.address.state}, {item.address.country}</li>
                                            </ul>
                                        </div>
                                    </div> : <span></span>}
                                </div>
                                <br/>
                                <div class="alert alert-success" style={{
                                    width: "100%",
                                    overflowX: "auto",
                                    whiteSpace: "nowrap",
                                }}>
                                    {item.games.map(game => (
                                        game.game_page ? <img style={{borderRadius: 5, marginRight: 5}} width="100" src={game.game_page.icon_url}></img> : <span></span>
                                    ))}
                                </div>
                                <small>On Easy Street from {(new Date(item.created_at)).toDateString()}</small>
                                <center><hr width="50%"/></center>
                            </a>
                        ))}
                    </div>
                </div>
            );
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>
    }
}
